<template>
  <section class="assistance">
    <div class="assistance-cont">
      <h2>Do you need assistance?</h2>
      <p>You can find <a href="/faq" target="_blank" aria-label="Answers to the frequently asked questions">
        answers to the frequently asked questions here</a>. If you have any additional questions,
        our customer support team will be happy to help you.</p>
      <a class="contact-us" :href="`/contact-us?message=This is in regards to propertyID S${property.id}`" target="_blank" aria-label="Contact us">Message</a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    property: Object,
  },
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.assistance {
  margin: 1.25rem 0;
  padding: 0 1.25rem;

  &-cont {
    padding: 0 0 1.25rem 0;
    border-bottom: 1px solid #D9D9D9;

    h2 {
      font-size: 1.25rem;
      line-height: 1.25rem;
      margin-bottom: 1.25rem;
    }

    p {
      font-size: 0.875rem;
      line-height: 1.125rem;

      a {
        color: $col_primary;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .contact-us {
      width: 100%;
      display: block;
      padding: .5rem;
      transition: .3s;
      font-weight: 700;
      text-align: center;
      font-size: 0.875rem;
      line-height: 1.125rem;
      margin-top: .625rem;
      color: $col_primary;
      border-radius: .25rem;
      text-decoration: none;
      box-sizing: border-box;
      background: transparent;
      border: 1px solid $col_primary;

      &:hover {
        transition: .3s;
        color: $col_white;
        background: $col_primary;
      }
    }
  }

  @media #{$desktop} {
    padding: 0;

    &-cont {
      h2 {
        font-size: 1.5rem;
        line-height: 1.813rem;
      }

      p {
        font-size: 1rem;
        line-height: 1.25rem;
      }

      .contact-us {
        font-size: 1rem;
        line-height: 1.25rem;
        margin-top: 1.25rem;
      }
    }
  }
}
</style>